import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { SkeletonLoader } from '@frontend/design-system';

export const KeywordSearchSkeletonLoader = () => {
  return (
    <div css={styles.containerStyle}>
      <div css={styles.rowStyle}>
        <SkeletonLoader height={24} width={24} shape='circle' />
        <div css={styles.contentStyle}>
          <SkeletonLoader height={20} width={155} />
          <SkeletonLoader height={18} css={styles.fullWidthStyle} />
          <SkeletonLoader height={18} width={315} />
        </div>
      </div>
    </div>
  );
};

const styles = {
  containerStyle: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
    padding: ${theme.spacing(1, 2)};
    border-bottom: 0.5px solid ${theme.colors.neutral20};
  `,
  rowStyle: css`
    display: flex;
    flex-wrap: wrap;
    gap: ${theme.spacing(1)};
    align-items: flex-start;
  `,
  contentStyle: css`
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: ${theme.spacing(1)};
  `,
  fullWidthStyle: css`
    width: 100%;
  `,
};
